<template>
  <div class="ajuda">
    <ul class="ajuda__lista">
      <li v-for="(item, indice) in conteudo.pontos" :key="indice" v-html="item" />
    </ul>
    <p v-if="conteudo.exemplo" class="ajuda__exemplo mb-0">
      <strong>Exemplo:</strong> <span v-html="conteudo.exemplo" />
    </p>
  </div>
</template>

<script>
/**
 * Conteúdo do "Como funciona" de cada etapa. Fica escondido por padrão: o que
 * confunde no cadastro de grade é o vocabulário (condição x variação x
 * agrupador), e quem já entendeu não precisa reler.
 *
 * Regra do texto: no máximo três pontos por etapa, um por conceito.
 */
const CONTEUDOS = {
  1: {
    pontos: [
      "Grade é a matriz em que o cliente compra várias variações do mesmo produto de uma vez.",
      "Este cadastro define duas coisas: <strong>quais produtos</strong> formam grade e <strong>quais atributos</strong> o cliente escolhe dentro dela.",
      "O nome é interno, para achar o grupo aqui no painel — o cliente nunca vê.",
    ],
    exemplo:
      "camiseta em 4 cores × 5 tamanhos = 20 SKUs numa matriz, em vez de 20 itens soltos.",
  },
  2: {
    pontos: [
      "Todas as condições precisam ser verdadeiras ao mesmo tempo. Não existe “ou” — se precisar de dois caminhos, crie dois grupos.",
      "A condição diz quem <strong>entra no grupo</strong>. Quem <strong>junta os SKUs na mesma matriz</strong> é o agrupador de grade do produto, que vem da carga do ERP (ajustável em Cadastros → Produtos → Informações Gerais).",
      "Produto sem agrupador nunca forma grade, mesmo casando com todas as condições.",
    ],
    exemplo: "Marca = Verso <strong>e</strong> Dimensão 2 = Camisetas.",
  },
  3: {
    pontos: [
      "Variação é o que muda de um SKU para o outro dentro da mesma grade: cor, tamanho, voltagem, sabor.",
      "O apelido é o nome que o cliente vê — use a palavra do negócio, não o nome da coluna.",
      "A ordenação automática entende 34…46 e PP, P, M, G, GG. Use <strong>Manual</strong> quando a ordem do seu negócio não é alfabética nem numérica.",
    ],
    exemplo: "Variação 1 → apelido “Cor”; Dimensão 3 → apelido “Tamanho”.",
  },
  4: {
    pontos: [
      "Depois de salvar, os canais (e-commerce, callcenter e força de vendas) passam a usar este grupo em até 10 minutos — é o tempo do cache.",
      "Grupo inativo fica salvo, mas não gera grade em nenhum canal: serve para preparar a configuração antes de liberar.",
    ],
  },
};

export default {
  name: "PainelAjuda",
  props: {
    etapa: { type: Number, required: true },
  },
  computed: {
    conteudo() {
      return CONTEUDOS[this.etapa] || CONTEUDOS[1];
    },
  },
};
</script>

<style scoped>
.ajuda {
  padding: 14px 16px;
  border-radius: 8px;
  background: #f2f2f8;
  font-size: 12.5px;
  line-height: 1.55;
  color: #475467;
}

.ajuda__lista {
  margin: 0;
  padding-left: 18px;
}

.ajuda__lista li + li {
  margin-top: 6px;
}

.ajuda__exemplo {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #dddce9;
}
</style>
